"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_isempty
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var isEmpty = function (obj) {
    return [Object, Array].indexOf((obj || {}).constructor) >= 0 &&
        !Object.keys(obj || {}).length;
};
exports.default = isEmpty;
